<template>
	<div class="login">
		<!-- 注册 -->
		<div class="login-top content-bag">
			<div class="login-content content-within">
				<div class="login-form content-form">
					<form action class="el-form tall-input">
						<!-- 手机号 -->
						<div class="el-form-item" style="margin: 30px 0">
							<div class="el-form-item__content">
								<div class="el-input">
									<!-- <input
                    type="text"
                    placeholder="手机号"
                    class="el-input__inner"
                    v-model="mobile"
                  /> -->
									<el-input type="text" v-model="mobile" placeholder="手机号"></el-input>
								</div>
							</div>
						</div>
						<!-- 密码 -->
						<div class="el-form-item" style="margin-bottom: 25px;">
							<div class="el-form-item__content">
								<div class="el-input">
									<!-- <input
                    type="password"
                    placeholder="密码"
                    class="el-input__inner"
                    v-model="Password"
                  /> -->
									<el-input v-if="visible" type="password" v-model="Password" placeholder="密码">
										<i slot="suffix" title="显示密码" class="iconfont icon-yanjingbi"
											style="cursor:pointer;margin-right:5px" @click="changePass('show')"></i>
									</el-input>
									<el-input v-else type="text" v-model="Password" placeholder="密码">
										<i slot="suffix" title="隐藏密码" class="iconfont icon-yanjing" style="cursor:pointer;margin-right:5px"
											@click="changePass('hide')"></i>
									</el-input>
								</div>
							</div>
						</div>
						<!-- 记住密码 忘记密码 -->
						<div class="el-form-item" style="margin-bottom: 22px;">
							<div class="el-form-item__content">
								<el-checkbox v-model="checked">记住密码
								</el-checkbox>
								<router-link to="/forget" class="right">忘记密码？
								</router-link>
							</div>
						</div>
						<!-- 登录 -->
						<div class="el-form-item" style="margin-bottom: 8px;">
							<div class="el-form-item__content" @click="login">
								<div class="el-button is-center el-button--primary">
									登录
								</div>
							</div>
						</div>
						<!-- 注册 -->
						<div class="el-form-item" style="margin-bottom: 8px;">
							<div class="el-form-item__content">
								<span>还没有账号？</span>
								<router-link to="/Register">立即注册
								</router-link>
							</div>
						</div>
						<div class="row-item" style="margin-bottom: 22px;">
							<el-checkbox v-model="radio" round></el-checkbox>
							<p style="font-size:14px;color:#606266;padding-left:10px">
								我已阅读并同意 <a @click="handleDialog">《{{ hyAgreement.chineseTitle }}》</a><a @click="handleDialog1">《{{
										privacyAgreement.chineseTitle
								}}》</a>
							</p>
						</div>
					</form>
				</div>
			</div>
		</div>
		<el-dialog :title="hyAgreement.chineseTitle" :visible.sync="dialogVisible" width="50%" append-to-body top="4vh">
			<div v-html="hyAgreement.imageContent"></div>
		</el-dialog>
		<el-dialog :title="privacyAgreement.chineseTitle" :visible.sync="dialogVisible1" width="50%" append-to-body
			top="4vh">
			<div v-html="privacyAgreement.imageContent"></div>
		</el-dialog>
		<!-- 底部 -->
		<Lrheder class="header"></Lrheder>

		<el-row class="footer" type="flex" justify="center">
			<div>友情链接：</div>
			<el-link class="item" href="http://www.hyxun.com/" target="_blank">海逊官网
			</el-link>
			<el-link class="item" href="http://cdt.kingtrans.net/new_index.jsp" target="_blank">辰达通物流
			</el-link>
			<el-link class="item" href="https://api.kuaidi100.com/" target="_blank">快递100
			</el-link>
		</el-row>
		<el-row class="Copyright" type="flex" justify="center">
			<div class="item">Copyright ©山西海逊贸易有限公司.All Rights Reserved <a class="link" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">晋ICP备19008855号-6
			</a></div>
		</el-row>
	</div>
</template>

<script>
import md5 from "md5";
import CryptoJS from "crypto-js";
import Lrheder from './Lrheader'
import { ajaxPost, Baseurl } from '../../api/api/api'
import { Message } from 'element-ui'
import { VerifyPermissions } from '../../utils/auxiliary'

// var str = window.location.href;
/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {string} queryName [参数名]
 * @return {string|null}           [参数值]
 */
function GetQueryValue(queryName, url) {
	let params = url.split('?')[1]
	let query = decodeURI(params);
	let vars = query.split("&");
	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split("=");
		if (pair[0] == queryName) {
			return pair[1];
		}
	}
	return null;
}

export default {
	name: 'login',
	data() {
		return {
			visible: true,
			checked: false,
			mobile: '',
			Password: '',
			hyAgreement: '',
			radio: true,
			privacyAgreement: '',
			dialogVisible: false,
			dialogVisible1: false
		}
	},
	components: {
		Lrheder,
	},
	mounted() {
		this.keyupEnter()
		// this.test()
		// this.GetUrlParms()
	},
	computed: {
		userInfo(){
			return JSON.parse(localStorage.getItem('role'));
		}
	},
	created() {
		// var str = window.location.href;
		let str = window.location.href;
		this.str = str;
        this.getJurisdictionInfo();
        // this.VerifyPermissions(); //校验是否需要授权
        this.PreservationCookie(); //使用之前记住的密码
	},
	methods: {
        VerifyPermissions,
		getTikTokToken(code){
			const api = Baseurl + 'tikTok2025Oauth/getAccessToken';
			ajaxPost(api, {code}).then((resp)=>{
				if(resp.data.code === 200){
					const res = resp.data.data;
					const access_token = res.access_token;
					const refresh_token = res.refresh_token;
					const params = {
						accessToken: access_token,
						refreshToken: refresh_token,
						company_id: this.userInfo.company_id,
					}
					ajaxPost(Baseurl + 'tikTok2025Seller/insertTikTokSellerInfo', params).then((res)=>{
						if(res.data.code === 200){
							this.$router.push({
								name: 'TikTokAuthorize',
							})
							this.$message.success('授权成功！')
						}else{
							this.$message.error(res.data.data)
						}
					})
				}else{
					this.$message.error(resp.data.data)
				}
				// 清空url的param数据
				const { pathname, hash } = window.location;
				const newUrl = hash ? pathname + hash : pathname;
				history.replaceState(null, '', newUrl);
			})
		},
		changePass(value) {
			this.visible = !(value === 'show')
		},
		getAccessToken(shop, code) {
			window.localStorage.setItem("shopifySellerId", shop)
			const API = Baseurl + 'oauth/authorization'
			const paramsData = {
				shop: shop,
				code: code
			}
			ajaxPost(API, paramsData)
				.then((res) => {
					if (res.data.code === 200) {
						this.$message.success('交换成功')
						window.localStorage.setItem("shopifyToken", res.data.data)
					} else {
						this.$message.error(res.data.data)
					}
				})
		},
		randomString(e) {
			e = e || 32
			let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456780',
				a = t.length,
				n = ''
			for (let i = 0; i < e; i++)
				n += t.charAt(Math.floor(Math.random() * a))
			return n
		},
		handleDialog() {
			this.dialogVisible = true;
			this.getJurisdictionInfo()
		},
		handleDialog1() {
			this.dialogVisible1 = true;
			this.getJurisdictionInfo()
		},
		getJurisdictionInfo() {
			const API = Baseurl + 'guanwangManageController/getJurisdictionInfo'
			const paramsData = {
				id: 78
			}
			ajaxPost(API, paramsData)
				.then((res) => {
					if (res.data.code === 200) {
						this.hyAgreement = res.data.data.guanwangImages[0]
						this.privacyAgreement = res.data.data.guanwangImages[1]
					}
				})
		},
		GetUrlParms() {
			let args = new Object()
			let query = window.location.search.substring(1) //获取查询串
			let pairs = query.split('&') //在逗号处断开

			for (let i = 0; i < pairs.length; i++) {
				let pos = pairs[i].indexOf('=') //查找name=value
				if (pos == -1) continue //如果没有找到就跳过
				let argname = pairs[i].substring(0, pos) //提取name
				let value = pairs[i].substring(pos + 1) //提取value
				args[argname] = unescape(value) //存为属性
			}
			return args
		},
		test() {
			let args = new Object()
			args = this.GetUrlParms()
			console.log(args)
			window.localStorage.setItem('query', JSON.stringify(args))
		},

		keyupEnter() {
			document.onkeydown = (e) => {
				if (this.$route.path === '/login') {
					if (e.keyCode === 13) {
						this.login()
					}
				}
			}
		},
		login() {
			// this.$router.push({ path: "/home/Thome" });
			let reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
			if (
				this.mobile === '' ||
				this.mobile === null ||
				this.mobile === undefined
			) {
				this.$message.error('请输入手机号码')
			} else if (!reg.test(this.mobile)) {
				this.$message.error('手机格式不正确')
			} else if (
				this.Password === '' ||
				this.Password === null ||
				this.Password === undefined
			) {
				this.$message.error('请填写密码')
			} else if (this.radio == false) {
				this.$message.warning("请阅读并勾选用户协议")
			} else {
				const wholeLoading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(255, 255, 255, 0.7)',
				})
				let url = Baseurl + 'userControllers/sign'
				let logininfo = {
					telephone: this.mobile,
					password: md5(this.Password),
					system: 1,
				}
				ajaxPost(url, logininfo)
					.then((res) => {
						if (res.data.code === 200) {
							// console.log(res.data.data.token);
							//token存在sessionStroge里
							window.sessionStorage.setItem(
								'token',
								res.data.data.token
							)
							window.localStorage.setItem(
								'token',
								res.data.data.token
							)
							window.localStorage.setItem(
								'data',
								JSON.stringify({
									data: res.data.data,
								})
							)
							if (
								Object.keys(res.data.data).length &&
								res.data.data.company &&
								res.data.data.jurisdiction &&
								res.data.data.roles &&
								res.data.data.user
							) {
								if (GetQueryValue('shop', this.str) !== null) {
									if (GetQueryValue('shop', this.str).indexOf('.myshopify.com') !== -1) {
										this.$router.push({
											name: 'ShopifyLicensing',
											params: { data: res.data.data },
										})
									} else if (GetQueryValue('shop', this.str).indexOf('.myshoplaza.com') !== -1) {
										this.$router.push({
											name: 'ShoplazzaAuthorize',
											params: { data: res.data.data },
										})
									} else {
										this.$router.push({
											name: 'Thome',
											params: { data: res.data.data },
										})
									}
								} else if (GetQueryValue('handle', this.str) !== null) {
									this.$router.push({
										name: 'ShoplineAuthorize',
										params: { data: res.data.data },
									})
								} else if (GetQueryValue('state', this.str) && GetQueryValue('state', this.str).indexOf('allegro') != -1) {
									this.$router.push({
										name: 'AllegroAuthorize',
										params: { data: res.data.data },
									})
								} else if (GetQueryValue('state', this.str) === 'wish') {
									window.localStorage.setItem("wish_code", GetQueryValue('code', this.str))
									this.$router.push({
										name: 'WishAuthorize',
										params: { data: res.data.data },
									})
								} else if (GetQueryValue('state', this.str) === 'eBay') {
									window.localStorage.setItem("eBay_code", GetQueryValue('code', this.str))
									this.$router.push({
										name: 'eBayAuthorize',
										params: { data: res.data.data },
									})
								} else if (GetQueryValue('state', this.str) === 'TikTok') {
									window.localStorage.setItem("TikTok_code", GetQueryValue('code', this.str))
									this.$router.push({
										name: 'TikTokAuthorize',
										params: { data: res.data.data },
									})
								} else if (GetQueryValue('state', this.str) === 'TikTok') {
									window.localStorage.setItem("TikTok_code", GetQueryValue('code', this.str))
									this.$router.push({
										name: 'TikTokAuthorize',
										params: { data: res.data.data },
									})
								}
								// else if(GetQueryValue('refresh')!==null){
								// 	this.$router.push({
								// 		name: 'PayPalAuthorize',
								// 		params: { data: res.data.data },
								// 	})
								// }
								else {
									this.$router.push({
										name: 'Thome',
										params: { data: res.data.data },
									})
								}
							} else {
								this.$router.push({
									path: '/NoRole',
								})
							}

							if (this.checked == true) {
								window.localStorage.setItem(
									'Account',
									JSON.stringify({
										mobile: this.mobile,
										password: this.Password,
									})
								)
							} else {
								this.clearStorage()
							}
							localStorage.setItem('loginTime', Date.now().toString()); // 毫秒时间戳
							const timerId = setTimeout(() => {
								this.$message.error('登录超时，请重新登录');
								this.$store.commit('loginOut')
								window.location.href = '/#/login'
							}, 604800000); // 7天后清除登录时间戳
							this.$store.commit('setTimeoutTimerId', timerId);
						} else {
							this.$confirm(res.data.data, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning',
							})
								.then(() => {
									// var url = "/api/userControllers/sign";
									// var str = {
									//     telephone: this.mobile,
									//     password: this.password
									// };
									// ajaxPost(url, str).then(res => {
									//     if (res.data.code === 200) {
									//         this.$message({
									//             type: "success",
									//             message: "登录成功!"
									//         });
									//         this.$router.push({
									//             path: "/box/Thome"
									//         });
									//         if (this.checked == true) {
									//             window.localStorage.setItem(
									//                 "Account",
									//                 JSON.stringify({
									//                     password: this.Password,
									//                     mobile: this.mobile
									//                 })
									//             );
									//             window.localStorage.setItem(
									//                 "data",
									//                 JSON.stringify({
									//                     data: res.data.data
									//                 })
									//             );
									//         } else {
									//             this.clearStorage();
									//         }
									//     }
									// });
								})
								.catch(() => {
									this.$message({
										type: 'info',
										message: '登录失败',
									})
								})
						}
					})
					.finally(() => {
						wholeLoading.close()
					})
			}
		},
		clearStorage() {
			localStorage.getItem('Account', {})
		},
		PreservationCookie() {
			this.Account = JSON.parse(window.localStorage.getItem('Account'))
			if (this.Account !== null) {
				this.checked = true
				this.Password = this.Account.password
				this.mobile = this.Account.mobile
			}
		},
		getCookie(cname) {
			var name = cname + '='
			console.log(document.cookie.split('='))
			var ca = document.cookie.split(';')
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i]
				while (c.charAt(0) == ' ') {
					c = c.substring(1)
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length)
				}
				this.$store.commit('set_cookie', c)
			}
			return ''
		},
		openOutsideLink(link) {
			window.open(link)
		},
	},
}
</script>

<style lang="scss" scoped>
.login {
	width: 100%;
	height: 100%;
	display: block;

	.tall-input {
		margin: 0 30px;

		.el-form-item__content {
			line-height: 40px;
			position: relative;
			font-size: 14px;

			.el-input {
				position: relative;
				font-size: 14px;
				display: inline-block;
				width: 100%;
			}

			.right {
				float: right;
				color: #2c559b;
			}

			a {
				color: #fe000e;
				text-decoration: underline;
				cursor: pointer;
			}

			.is-center {
				width: 100%;
				letter-spacing: 2px;
			}

			.el-button--primary {
				color: #fff;
				background-color: #194f7b;
				border-color: #194f7b;
			}
		}

		.row-item {
			display: flex;

			a {
				color: #194f7b;
				cursor: pointer;
			}

			/deep/ .el-checkbox__inner {
				border-radius: 50%;
			}
		}
	}

	.footer {
		padding: 10px;

		.item {
			margin: 0 10px;
		}
	}
}
.Copyright{
	padding-bottom: 10px;
	.link{
		color: rgb(76, 180, 231);
		&:hover{
			text-decoration: none;
		}
	}
}
</style>
